import { z } from 'zod';
export const PAGE_LIMIT_DEFAULT = 25;
export const PAGE_LIMIT_MAX = 100;
/**
 * Cursor pagination query for every list endpoint (Docs/API.md §1.7).
 * Cursors are opaque, signed, and bound to the tenant and the sort; a cursor from
 * another query is rejected with 400 VALIDATION_FAILED by the endpoint, not here.
 */
export const PageQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(PAGE_LIMIT_MAX).default(PAGE_LIMIT_DEFAULT),
    cursor: z.string().min(1).optional(),
});
export const PageInfoSchema = z.object({
    nextCursor: z.string().nullable(),
    limit: z.number().int().min(1).max(PAGE_LIMIT_MAX),
});
/** `{ data: {...} }` for a single resource (Docs/API.md §1.2). */
export function resource(schema) {
    return z.object({ data: schema });
}
/** `{ data: [...], page: {...} }` for a list. */
export function paginated(schema) {
    return z.object({ data: z.array(schema), page: PageInfoSchema });
}
//# sourceMappingURL=pagination.js.map